import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { DesignationLevel } from '../../models/designationlevel';
import { DesignationLevelService } from '../../services/designationlevel.service';
import { CoreSaveService, ConfigService, UtilsService, MessageService, ICommonMessage, FieldType } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { DatePipe } from '@angular/common';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-designationlevel',
  templateUrl: './designationlevel.component.html',
  styleUrls: ['./designationlevel.component.css']
})
export class DesignationLevelComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerDesignationLevel: PageHeader;
  entity: DesignationLevel = new DesignationLevel();
  editingEntity: DesignationLevel = new DesignationLevel();
  selectedDesignationLevel: DesignationLevel = new DesignationLevel();
  designationlevels: any;
  designationlevelColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  pipe = new DatePipe('en-US');
  emailcheck: boolean = true;
  defaultRowsCount: number;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  saveDisabled: boolean = false;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  constructor(
    private _designationlevelService: DesignationLevelService,
    private configService: ConfigService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerDesignationLevel = this.initPageHeader();
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');

    this.designationlevelColumns = [
      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 50 },
      { field: "DesignationLevelName", title: 'Name', filter: true, sortable: true, width: 120 },
      { field: "Description", title: 'Description', filter: true, sortable: true, width: 120 },
      { field: "OrderNo", title: 'Order', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true, width: 100 },
    ];
    this.designationlevels = [];
    this.getAllDesignationLevels();
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._designationlevelService.getAllDesignationLevel('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<DesignationLevel>) => {
      this.designationlevels = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }

  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._designationlevelService.getAllDesignationLevel(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((designationlevels: Array<DesignationLevel>) => {
        this.designationlevels = {
          data: designationlevels,
          total: designationlevels[0] ? designationlevels[0].TotalCount : 0
        }
      });
    }
  }
  getAllDesignationLevels() {
    this._designationlevelService.getAllDesignationLevel('', Number(this.defaultPageSize), 1, 0, 0).subscribe((designationlevels: Array<DesignationLevel>) => {
      this.designationlevels = {
        data: designationlevels,
        total: designationlevels[0].TotalCount
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._designationlevelService.deleteDesignationLevel(this.selectedDesignationLevel.Designation_Level_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearDesignationLevel();
            this.getAllDesignationLevels();
          },
          )
        }
      }
    });
  }
  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }
  }
  initPageHeader(): PageHeader {
    let headerDesignationLevel = new PageHeader();
    headerDesignationLevel.PageCaption = "Designation Level";
    headerDesignationLevel.IconClass = "bi bi-building";
    return headerDesignationLevel;
  }

  deleteDesignationLevel(event: any) {
    if (event.seletedRows[0]) {
      this.selectedDesignationLevel.Designation_Level_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Designation Level",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addDesignationLevel(event: any) {
    this.listView = false;
    this.clearDesignationLevel();
    this.formCaption = "Add Designation Level";
  }

  editDesignationLevel(event: any): void {
    if (event.seletedRows[0]) {
      this._designationlevelService.viewDesignationLevel(event.seletedRows[0]).subscribe((designationlevels: Array<DesignationLevel>) => {
        let editDesignationLevel = designationlevels[0] ? designationlevels[0] : new DesignationLevel();
        if (editDesignationLevel) {
          this.editingEntity = editDesignationLevel;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Designation Level";
          this.entity.EntityMetaData = [
            { FieldName: 'DesignationLevelName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'DesignationLevel Name is required' },
            { FieldName: 'OrderNo', FieldType: FieldType.Integer, IsMandatory: true, ValidationMessage: 'Order No. is required' },

          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._designationlevelService.checkDuplication(this.entity.DesignationLevelName, this.entity.Designation_Level_Id).subscribe((res) => {
        if (res.Success == false) {
          this.notification.showWarning('Designation Level already exists');
          this.saveDisabled = false;
        }
        const re = /^(0*[1-9]+0*)+$/;
     
        this.codeCheck = re.test(String(this.entity.OrderNo).toString());
       
        if (this.codeCheck==false ) {
         
          this.notification.showWarning("Invalid code ");
          this.saveDisabled = false;
          
        }
        else {
          this._designationlevelService.saveDesignationLevel(this.entity).subscribe(() => {
            if (this.entity.Designation_Level_Id == "00000000-0000-0000-0000-000000000000") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearDesignationLevel();
            this.getAllDesignationLevels();
          })
        }
      });
    }

    else {
      this.saveDisabled = false;
    }
  }

  gotoBack(): void {
    this.listView = true;
    this.clearDesignationLevel();
  }
  refreshDesignationLevel(event: any): void {
    this.designationlevels=[];
    this.getAllDesignationLevels();
  }
  clearDesignationLevel(): void {
    this.entity = new DesignationLevel();
    this.saveDisabled = false;
  }
  onExcelExport() {
    this.excelexport.save()
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
